module.exports = __webpack_public_path__ + "static/img/3.a9642ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/sanliouLinkage/third/3.png
// module id = tGjr
// module chunks = 6